import React from 'react';
import "./Quiz.css";

function Quiz() {
  return (
    <div className='quizContainer'>
        <p className="displayMessage">Comming Soon...</p>
        <p className='smallText'>Stay Tuned</p>
    </div>
  )
}

export default Quiz